<template>
    <div class="list-select-con">
        <!-- 已选条件 -->
        <div class="list-select-result-con" v-show="getSelectedFiters().length > 0">
            <div class="result-text">
                共<span id="cruise--list-cout" style="color:#006ab9">{{cruiseCount}}</span>条
            </div>
            <div class="result-text" style="margin-right: 15px; width: 61px">
                已选条件:
            </div>
            <div class="result-con">

                <div class="result-item" v-for="(filter, i) in getSelectedFiters()" :key="i" >
                    <div class="result-item-label">{{getTypeNameByFilter(filter.key)}}</div>
                    <div style="color:#006ab9; float: left;line-height: 25px;">{{filter.name}}</div>
                    <img style="margin-left: 4px; width: 10px; float: left; margin-top: 7px;"
                        src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-close-blue-1.jpg"
                        @click="onFilterRemove(filter.code, filter.key, filter.name)"
                        >
                </div>
            </div>
            <a class="result-clear-all" @click="clearCruiseFilter()">清空全部</a>
            <div class="clear"></div>
        </div>

        <!-- 筛选条件 -->
        <div class="list-select-list-con fw-400">
            <!-- 出发港口 -->
            <div class="select-item">
                <div class="select-label" style="align-items: center;">出发港口:</div>
                <div class="address-select-con select-left">
                    <div class="check-item-con ship-check-item-con"
                    :class="{ active: isCategorySelectAll('departures')}"
                    @click="categorySelectedAllClick('departures')">
                        <img class="float-left selected-icon" style="margin-right: 6px"
                            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                        <img class="float-left unselected-icon" style="margin-right: 6px"
                            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                        <div class="float-left">不限</div>
                    </div>
                    <div class="check-item-con ship-check-item-con" v-for="(departure, i) in departures" :key="('departure_' + i)"
                     :class="{ active: isSelected(departure.filterCode, 'departures'), disable: isDisabled(departure.filterCode, 'departures')}"
                     @click="onFilterClick(departure.filterCode, 'departures', departure.title)"
                    >
                        <img class="float-left selected-icon" style="margin-right: 6px"
                            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                        <img class="float-left unselected-icon" style="margin-right: 6px"
                            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                        <img class="float-left disable-icon" style="margin-right: 6px"
                            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                        <div class="float-left link_text">{{departure.title}}</div>
                    </div>

                </div>
                <a class="goto-hp" href="javascript:void(0)" @click="handleROWLink"><img class="changeHomeCruise"
                        src="https://resource.rcclchina.com.cn/tui2/changeToRowCruise.gif"></a>
            </div>
            <div class="line"></div>
          <div class="select-item" style="min-height: 44px;">
            <div class="select-label">游轮名称:</div>
            <div class="address-select-con select-left">
              <div class="check-item-con ship-check-item-con"
                   :class="{ active: isCategorySelectAll('shipCodes')}"
                   @click="categorySelectedAllClick('shipCodes')">
                <img class="float-left selected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                <img class="float-left unselected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                <div class="float-left">不限</div>
              </div>
              <div class="check-item-con ship-check-item-con" v-for="(ship) in shipCodes" :key="ship.shipCode"
                   :class="{ active: isSelected(ship.filterCode, 'shipCodes'), disable: isDisabled(ship.filterCode, 'shipCodes')}"
                   @click="onFilterClick(ship.filterCode, 'shipCodes', ship.title)"
                   @mouseenter="showShipTips=ship.filterCode"
                   @mouseleave="showShipTips=''"
              >
                <img class="float-left selected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                <img class="float-left unselected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                <img class="float-left disable-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                <div class="float-left link_text">
                  <div class="float-left link_text">{{ship.title}}</div>
                  <div class="float-left" style="width: 35px; position: relative;height: 13px; top: 2px;"
                       v-if="ship.isNew || ship.isHot">
                    <img class="check-item-con-ship-new" v-if="ship.isNew"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-new.jpg">
                    <img class="check-item-con-ship-new" v-if="ship.isHot"
                         src="https://resource.rcclchina.com.cn/cruiseSearch/pc_hot_icon.png">
                  </div>
                </div>
                <div class="check-item-con-ship-tonnage" v-show="showShipTips==ship.filterCode">
                  <div class="tonnage-tooltip-arrow"></div>
                  <div class="tonnage-tooltip-inner">{{ship.cruiseFilterGroupName}}</div>
                </div>
              </div>
            </div>
          </div>
            <!-- 游轮名称 -->
            <div class="line"></div>

          <!-- 出发时间 -->
          <div class="select-item" id="sailDateFilter" style="overflow:hidden">
            <div class="select-item-list-con">
              <div class="select-label">出发时间:</div>
              <div class="address-select-con select-left" :style="{height:!isShowMoreSailDates ? '40px' : 'auto'} ">
                <div class="check-item-con"
                     :class="{ active: isCategorySelectAll('sailDates')}"
                     @click="categorySelectedAllClick('sailDates')">
                  <img class="float-left selected-icon" style="margin-right: 6px"
                       src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                  <img class="float-left unselected-icon" style="margin-right: 6px"
                       src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                  <div class="float-left">不限</div>
                </div>

                <div v-for="(year) in months" :key="('year_'+ year.year)">
                  <div class="time-year float-left">{{year.year}}</div>
                  <div class="check-item-con" v-for="(month) in year.months" :key="('year_'+ year.year+'_' + month.month)"
                       :class="{ active: isSelected(month.monthStr, 'sailDates'), disable: isDisabled(month.monthStr, 'sailDates')}"
                       @click="onFilterClick(month.monthStr, 'sailDates', month.monthStr)">
                    <img class="float-left selected-icon" style="margin-right: 6px"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                    <img class="float-left unselected-icon" style="margin-right: 6px"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                    <img class="float-left disable-icon" style="margin-right: 6px"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                    <div class="float-left">{{month.month}}月</div>
                  </div>
                </div>
              </div>
              <!-- </div> -->
            </div>
            <div class="select-time-more-con" @click="onShowMoreSailDates">
              <div class="select-time-more">
                <div id="timeMoreText" class="float-left">{{isShowMoreSailDates ? '收起': '更多'}}</div>
                <img id="timeMoreImg" class="float-left"
                     style="margin-left: 4px;height: 5px;margin-top: 8px;"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-down-blue.jpg">
                <div class="clear"></div>
              </div>
            </div>
          </div>

          <div class="select-item" v-if="festiveHoliday.length>0"  v-show="isShowMore">
            <div class="line"></div>
            <div class="select-label">节庆假日:</div>
            <div class="address-select-con select-left">
              <div class="check-item-con"
                   v-for="(tag, i) in festiveHoliday" :key="i"
                   :class="{ active: isSelected(tag.tagType, 'tags'), disable: isDisabled(tag.tagType, 'tags')}"
                   @click="onFilterClick(tag.tagType, 'tags', tag.tagType)"
              >
                <img class="float-left selected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                <img class="float-left unselected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                <img class="float-left disable-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                <div class="float-left">{{ tag.tagType }}</div>
              </div>
            </div>
          </div>
          <!-- 行程晚数 -->
          <div class="select-item" style="height: 44px;"  v-show="isShowMore">
            <div class="line"></div>
            <div class="select-label">航程晚数:</div>
            <div class="address-select-con select-left">
              <div class="check-item-con sailDate-check-item-con"
                   :class="{ active: isCategorySelectAll('sailDays')}"
                   @click="categorySelectedAllClick('sailDays')">
                <img class="float-left selected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                <img class="float-left unselected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                <div class="float-left">不限</div>
              </div>
              <div class="check-item-con sailDate-check-item-con"
                   @click="onFilterClick(3, 'sailDays', '3晚及以下')"
                   :class="{ active: isSelected(3, 'sailDays'), disable: isDisabled(3, 'sailDays')}"
              >
                <img class="float-left selected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                <img class="float-left unselected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                <img class="float-left disable-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                <div class="float-left">3晚及以下</div>
              </div>
              <div class="check-item-con sailDate-check-item-con"
                   @click="onFilterClick(4, 'sailDays', '4晚')"
                   :class="{ active: isSelected(4, 'sailDays'), disable: isDisabled(4, 'sailDays')}"
              >
                <img class="float-left selected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                <img class="float-left unselected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                <img class="float-left disable-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                <div class="float-left">4晚</div>
              </div>
              <div class="check-item-con sailDate-check-item-con"
                   @click="onFilterClick(5, 'sailDays', '5晚')"
                   :class="{ active: isSelected(5, 'sailDays'), disable: isDisabled(5, 'sailDays')}">
                <img class="float-left selected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                <img class="float-left unselected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                <img class="float-left disable-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                <div class="float-left">5晚</div>
              </div>
              <div class="check-item-con sailDate-check-item-con"
                   @click="onFilterClick(6, 'sailDays', '6晚及以上')"
                   :class="{ active: isSelected(6, 'sailDays'), disable: isDisabled(6, 'sailDays')}"
              >
                <img class="float-left selected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                <img class="float-left unselected-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                <img class="float-left disable-icon" style="margin-right: 6px"
                     src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                <div class="float-left">6晚及以上</div>
              </div>
            </div>
          </div>
            <!-- 更多筛选隐藏部分 -->
<!--            <div id="selectMore" :class="{ showMoreSelect: isShowMore}" style="width: 100%;">-->
              <!-- 目的地 -->
              <div class="select-item select-destinations" style="padding: 0;">
                <div class="line"></div>
                <div class="select-label css_destination" style="align-items: center;">目的地:</div>
                <div class="address-select-con select-left">
                  <div class="address-select-item-box">
                    <div class="check-item-con"
                         :class="{ active: isCategorySelectAll('destinations')}"
                         @click="categorySelectedAllClick('destinations')">
                      <img class="float-left selected-icon" style="margin-right: 6px"
                           src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                      <img class="float-left unselected-icon" style="margin-right: 6px"
                           src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                      <div class="float-left">不限</div>
                    </div>
                  </div>

                  <div class="address-select-item-box" v-for="(destSubCategory, i) in destinationSubCategories" :key="('dest_'+i)"
                       @mouseenter="showDestGroupIndex=i"
                       @mouseleave="showDestGroupIndex=-1">
                    <div class="address-select-item-con" style="">
                      <div style="float: left;">{{destSubCategory}}</div>
                      <div class="red-dot" v-show="checkDestinationSubGroupSelected(destSubCategory)"></div>
                      <img class="address-selected-icon" style="margin-left: 4px;float: left;margin-top: 8px;"
                           src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-up-blue.jpg">
                      <img class="address-unselected-icon"
                           style="margin-left: 4px;float: left;margin-top: 8px;"
                           src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-down-1.jpg">
                    </div>
                    <div class="address-select-list-con" v-show="showDestGroupIndex==i">
                      <div class="address-select-product"
                           v-for="(group, j) in getFilterGroups(destSubCategory)" :key="('dest_' + i + '_' + j)">
                        <div class="address-select-product-name">
                          <div class="name-line"></div>
                          <div class="name-text">{{group}}</div>
                        </div>
                        <div class="address-select-product-items">
                          <div class="check-item-con check-item-con-all"
                               :class="{ active: checkDestinationAllSelected(group, destSubCategory)
                                        , disable: checkDestinationAllDisabled(group, destSubCategory)}"
                               @click="onDestAllSelected(group, destSubCategory)"
                          >
                            <img class="float-left selected-icon" style="margin-right: 6px"
                                 src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                            <img class="float-left unselected-icon" style="margin-right: 6px"
                                 src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                            <img class="float-left disable-icon" style="margin-right: 6px"
                                 src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                            <div class="float-left">全部</div>
                          </div>

                          <div class="check-item-con" v-for="(dest, k) in getDestinationsByGroup(group, destSubCategory)"
                               :key="dest.filterCode+'_'+k"
                               :class="{ active: isSelected(dest.filterCode, 'destinations'), disable: isDisabled(dest.filterCode, 'destinations')}"
                               @click="onFilterClick(dest.filterCode, 'destinations', dest.title)"
                          >
                            <img class="float-left selected-icon" style="margin-right: 6px"
                                 src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                            <img class="float-left unselected-icon" style="margin-right: 6px"
                                 src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                            <img class="float-left disable-icon" style="margin-right: 6px"
                                 src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                            <div class="float-left">{{dest.title}}</div>
                            <div class="float-left" v-if="dest.isNew || dest.isHot"
                                 style="width: 35px; position: relative;height: 13px;margin-right: 4px; top: -1px;">
                              <img class="check-item-con-ship-new" v-if="dest.isNew"
                                   src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-new.jpg">
                              <img class="check-item-con-ship-new" v-if="dest.isHot"
                                   src="https://resource.rcclchina.com.cn/cruiseSearch/pc_hot_icon.png">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
                <div class="line"></div>
                <!-- 热门标签 -->
<!--                <div class="select-item">-->
<!--                    <div class="select-label">热门标签:</div>-->
<!--                    <div class="address-select-con select-left">-->
<!--                        <div class="check-item-con" -->
<!--                        v-for="(tag, i) in tags" :key="i" -->
<!--                        :class="{ active: isSelected(tag.tagType, 'tags'), disable: isDisabled(tag.tagType, 'tags')}"-->
<!--                        @click="onFilterClick(tag.tagType, 'tags', tag.tagType)"-->
<!--                        >-->
<!--                            <img class="float-left selected-icon" style="margin-right: 6px"-->
<!--                                src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">-->
<!--                            <img class="float-left unselected-icon" style="margin-right: 6px"-->
<!--                                src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">-->
<!--                            <img class="float-left disable-icon" style="margin-right: 6px"-->
<!--                                src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">-->
<!--                            <div class="float-left">{{tag.tagType}}</div>-->
<!--                        </div>-->

<!--                    </div>-->
<!--                    <div class="clearfix"></div>-->
<!--                </div>-->
              <div class="select-item" v-if="tagPromoList.length>0"  v-show="isShowMore">
                <div class="select-label">优惠促销:</div>
                <div class="address-select-con select-left">
                  <div class="check-item-con"
                       v-for="(tag, i) in tagPromoList" :key="i"
                       :class="{ active: isSelected(tag.tagType, 'tags'), disable: isDisabled(tag.tagType, 'tags')}"
                       @click="onFilterClick(tag.tagType, 'tags', tag.tagType)"
                  >
                    <img class="float-left selected-icon" style="margin-right: 6px"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                    <img class="float-left unselected-icon" style="margin-right: 6px"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                    <img class="float-left disable-icon" style="margin-right: 6px"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                    <div class="float-left">{{ tag.tagType }}</div>
                  </div>
                </div>
              </div>
              <div class="select-item" v-if="tagThemeList.length>0"  v-show="isShowMore">
                <div class="line"></div>
                <div class="select-label">主题/联名房:</div>
                <div class="address-select-con select-left">
                  <div class="check-item-con"
                       v-for="(tag, i) in tagThemeList" :key="i"
                       :class="{ active: isSelected(tag.tagType, 'tags'), disable: isDisabled(tag.tagType, 'tags')}"
                       @click="onFilterClick(tag.tagType, 'tags', tag.tagType)"
                  >
                    <img class="float-left selected-icon" style="margin-right: 6px"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg">
                    <img class="float-left unselected-icon" style="margin-right: 6px"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg">
                    <img class="float-left disable-icon" style="margin-right: 6px"
                         src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-disable-1.png">
                    <div class="float-left">{{ tag.tagType }}</div>
                  </div>

                </div>
                <div class="clearfix"></div>
              </div>
<!--            </div>-->

            <!-- 更多筛选 -->
            <div class="list-more-select-con" @click="isShowMore=!isShowMore">
                <div class="more-container" style="margin-top: 4px;">
                    <span id="selectMoreText">{{ isShowMore ? "收起更多筛选": "更多筛选"}}</span>
                    <img id="selectMoreIcon" style="margin-left: 4px" :class="{ rotate180: isShowMore}"
                        src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-more-select-down.jpg">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import {gioTracking} from "@/utilities/tools";
export default {
    name: "CruiseSearchFilter",
    props: {
        cruiseFilters: {
            type: Array,
            default () {
                return []
            }
        },
        initSelectFilterCodes: {
            type: Object,
            default () {
                return {
                    "departures": [],
                    "destinations": [],
                    "sailDates": [],
                    "sailDays": [],
                    "shipCodes": [],
                    "tags": [],
                    "keyword": ""
                }
            }
        },
        showFilterCategory: {
            type: String,
            default () {
                return ""
            }
        },
        months: {
            type: Array,
            default () {
                return []
            }
        },
        shipCodes: {
            type: Array,
            default () {
                return []
            }
        },
        departures: {
            type: Array,
            default () {
                return []
            }
        },
        destinations: {
            type: Array,
            default () {
                return []
            }
        },
        tags: {
            type: Array,
            default () {
                return []
            }
        },
        tagFilters: {
            type: Array,
            default () {
                return []
            }
        },
        festiveHoliday:{
            type: Array,
            default () {
                return []
            }
        },
        tagPromoList:{
          type: Array,
          default () {
            return []
          }
        },
        tagThemeList:{
          type: Array,
          default () {
            return []
          }
        },
        filterConfirmHandler: {
            type: Function
        },
        onClearCruiseFilter: {
            type: Function
        }
    },
    data () {
        return {
            selectFilterCodes: [],
            selectedAlls: {
                departures: false,
                sailDates: false,
                shipCodes: false,
                destinations: false,
                sailDays: false
            },
            isShowMoreSailDates: false,
            showShipTips: '',
            showDestGroupIndex: -1,
            isShowMore: false,
        }
    },
    beforeMount () {
        this.initFilterData(this.initSelectFilterCodes)
    },
    mounted () {

    },
    methods: {
        // 初始化选中的条件
        initFilterData (initFilters) {
            let filters = []
            Object.keys(initFilters).forEach((key) => {
                if (key != "keyword") {
                    if (key.indexOf("orderBy") >= 0) {
                        filters.push({ code: initFilters[key], name: '', key: key})
                    } else if (initFilters[key].length > 0) {
                        initFilters[key].forEach((item) => {
                            if ((item.code && item.code.length > 0) || key == 'sailDays') {
                                let name = item.name + ''
                                if (!item.name) {
                                    if (key == 'sailDays') {
                                        if (item.code == 4) name = "4晚"
                                        else if (item.code == 3) name = "3晚及以下"
                                        else if (item.code == 5) name = "5晚"
                                        else if (item.code > 5) name = "6晚及以上"
                                    } else {
                                        name = this.getFilterName(item.code)
                                    }
                                }
                                filters.push({ code: item.code, name: name, key: key})
                            }
                        })
                    }
                }
            })
            this.selectFilterCodes = filters
        },
        // 判断条件是否已选中
        isSelected (code, key) {
            if (!code || code.length == 0) return false
            return this.selectFilterCodes.filter(r=>r.code == code && r.key ==key).length > 0
        },
        // 判断条件是否已禁用
        isDisabled (code, key) {
            if (key == 'sailDays') {
                const filterResponse = this.$store.state.cruise.filterResponse.hp['sailDays']
                code+= 1
                if (code > 6) {
                    return !(filterResponse.filter(r=> r >= code).length > 0)
                } else {
                    return !filterResponse.includes(code)
                }
            } else {
                if (!code || code.length == 0) return false
                const filterResponse = this.$store.state.cruise.filterResponse.hp[key]
                if (typeof(code) == "string" && code.indexOf(',')>=0) {
                    return !filterResponse.some(r=> code.indexOf(r) >= 0)
                }
                return !filterResponse.includes(code)
            }

        },
        // 点击某个条件
        onFilterClick (code, key, name) {
            if (!code || code.length == 0 || !key || key.length == 0) return
            let data = {
                cruiseType: 'hp',
                key: key,
                values: []
            }
            const item = { code: code, name: name }
            data.values.push(item)

            if (this.isSelected(code, key)) {
                // 反选
                this.selectFilterCodes = this.selectFilterCodes.filter(r=>r.code != code)
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            } else {
                if (this.isDisabled(code, key)) return
                this.selectFilterCodes.push({ code: item.code, name: item.name, key: key})
                this.$store.dispatch('SET_CRUISE_FILTERS', data)
            }
            this.filterConfirmHandler(this.selectFilterCodes)
        },
        onFilterRemove (code, key, name) {
            if (key.indexOf('orderBy') < 0) {
                let data = {
                    cruiseType: 'hp',
                    key: key,
                    values: [{ code: code, name: name }]
                }
                this.selectFilterCodes = this.selectFilterCodes.filter(r=>r.code != code)
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            } else {
                this.setOrderByValue('orderBysailDate', 1)
            }
            this.filterConfirmHandler(this.selectFilterCodes)
        },
        // 根据展开的category, 获取已选中的条件
        getSelectedFiters () {
            return this.selectFilterCodes.filter(r=>r.name && r.name.length > 0)
        },
        // 从页面cruise filters中获取code对应中文名
        getFilterName (code) {
            const items = this.cruiseFilters.filter(r=>r.filterCode == code)
            return items.length > 0 ? items[0].title : ""
        },
        onDestAllSelected(group, subCategory) {
            // const items = this.getDestinationsByGroup(group, subCategory)
            if (this.checkDestinationAllSelected(group, subCategory)) {
                // 如果已经选中，反选
                const items = this.getDestinationsByGroup(group, subCategory).map(r=>r.filterCode)
                const selected = this.selectFilterCodes.filter(r=>r.key == "destinations")
                const needRemove = selected.filter(r=>items.includes(r.code))
                if (needRemove.length > 0) {
                    let data = {
                        cruiseType: 'hp',
                        key: 'destinations',
                        values: needRemove
                    }
                    this.selectFilterCodes = this.selectFilterCodes.filter(r=> !items.includes(r.code))
                    this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
                }
            } else {
                // 检查是否已经禁用
                if (this.checkDestinationAllDisabled(group, subCategory)) {
                    return
                }
                // 取出没有被选中的，添加到selected中
                const selected = this.selectFilterCodes.filter(r=>r.key == "destinations").map(r=>r.code)
                const items = this.getDestinationsByGroup(group, subCategory).filter(r=> !selected.includes(r.filterCode))

                if (items.length > 0) {
                    let data = {
                        cruiseType: 'hp',
                        key: 'destinations',
                        values: []
                    }
                    items.forEach((item) => {
                        if (!this.isDisabled(item.code, 'destinations')) {
                            this.selectFilterCodes.push({ code: item.filterCode, key: 'destinations', name: item.title})
                            data.values.push({ code: item.filterCode, key: 'destinations'})
                        }
                    })
                    this.$store.dispatch('SET_CRUISE_FILTERS', data)
                }
            }
            this.filterConfirmHandler(this.selectFilterCodes)
        },
        // 替换目的地大类名称
        getSubCategoryName (subCategory) {
            if (subCategory.indexOf('/') > 0) {
                return subCategory.split("/").join("<br/>")
            } else {
                return subCategory
            }
        },
        onOrderByClick (key, code) {
            if (code <= 0 || code > 2) return
            this.setOrderByValue(key, code)
        },

        // 根据目的地分类获取目的地分组
        getFilterGroups (subCategory) {
            let groups = []
            this.destinations.forEach((destination) => {
                if (destination.cruiseFilterGroupSubCategory == subCategory
                    && destination.countryName && destination.countryName.length > 0) {
                        const groupName = destination.cruiseFilterGroupName
                        if (!groups.includes(groupName)) {
                            groups.push(groupName)
                        }
                    }
            })
            return groups
        },
        // 根据目的地分类获取所有目的地
        getDestinationsBySubCategory (subCategory) {
            return this.destinations.filter(item => item.cruiseFilterGroupSubCategory == subCategory)
        },
        // 根据目的地分类和分组，获取所有目的地
        getDestinationsByGroup (group, subCategory) {
            let dests = this.destinations.filter(item =>
            item.cruiseFilterGroupSubCategory == subCategory && item.cruiseFilterGroupName == group)

            return _.orderBy(dests, 'seq')
        },
        // 检查全部按钮是否需要选中
        checkDestinationAllSelected(group, subCategory) {
            const dests = this.getDestinationsByGroup(group, subCategory).map(r=>r.filterCode)
            const seleted = this.selectFilterCodes.filter(r=> r.key == 'destinations').map(r=>r.code)
            return dests.every(dest => seleted.includes(dest))
        },
        // 检查全部按钮是否需要禁用
        checkDestinationAllDisabled(group, subCategory) {
            const dests = this.getDestinationsByGroup(group, subCategory).map(r=>r.filterCode)
            const availableItems = this.$store.state.cruise.filterResponse['hp'].destinations
            return !availableItems.some(item=> dests.includes(item))
        },
        checkDestinationSubGroupSelected (subCategory) {
            const destinations = this.getDestinationsBySubCategory(subCategory)
            let hasSelected = false
            for (let i = 0; i < destinations.length; i++) {
                const code = destinations[i].filterCode
                if (this.selectFilterCodes.some(r=>code.indexOf(r.code) >= 0)) {
                    hasSelected = true
                    break
                }
            }
            return hasSelected
        },
        getTagFilter (tagType) {
            const tagFilter = this.tagFilters.filter(r=>r.title == tagType)
            return tagFilter.length > 0 ? tagFilter[0] : {}
        },
        getTypeNameByFilter (filter) {
            switch (filter) {
                case 'departures': return '出发港口'
                case 'sailDates': return '出发时间'
                case 'sailDays': return '行程晚数'
                case 'destinations': return '目的地'
                case 'shipCodes': return '游轮名称'
                case 'tags': return '热门标签'
                default: return ''
            }
        },
        isCategorySelectAll(category) {
            return this.selectedAlls[category]
        },
        categorySelectedAllClick(category) {
            let isSelectAll = this.isCategorySelectAll(category)
            if (isSelectAll) {
                this.selectedAlls[category] = false
            } else {
                // 选择不限，删除filter code中同类型的item
                this.selectedAlls[category] = true
                const needRemove = this.selectFilterCodes.filter(r=>r.key == category)
                if (needRemove.length > 0) {
                    let data = {
                        cruiseType: 'hp',
                        key: category,
                        values: needRemove
                    }
                    this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
                }
                this.selectFilterCodes = this.selectFilterCodes.filter(r=>r.key != category)
                this.filterConfirmHandler(this.selectFilterCodes)
            }
        },
        clearCruiseFilter () {
            this.selectFilterCodes = []
            this.onClearCruiseFilter()
        },
        onShowMoreSailDates(){
            this.isShowMoreSailDates=!this.isShowMoreSailDates
        },
        handleROWLink() {
          gioTracking('track', 'evt_ButtonClicked',{
            'btnType': `CruiseSearchFilterROW`
          })
        //   window.location.href = 'https://www.rclrow.com/Cruise/Search'
            this.$router.push({
             path: '/Rccl.Cruise/CruiseSearch/SearchRow'
            })
        }
    },
    computed: {

        destinationSubCategories () {
            let groupSubCategories = []
            this.destinations.forEach((filter) => {
                const subCategory = filter.cruiseFilterGroupSubCategory
                if (!groupSubCategories.includes(subCategory)) {
                    groupSubCategories.push(subCategory)
                }
            })
            return groupSubCategories
        },
        cruiseCount () {
            const storedCruiseLists = this.$store.state.cruise.cruiseLists || {}
            if (storedCruiseLists) return storedCruiseLists.count
            return 0
        }
    },
    watch: {
        initSelectFilterCodes: {
            handler(newOne) {
                this.initFilterData(newOne)
            },
            deep: true
        } ,
        selectFilterCodes (newValue) {
            if (this.selectedAlls.departures) {
                if (newValue.some(r=>r.key=="departures")) {
                    this.selectedAlls.departures = false
                }
            }

            if (this.selectedAlls.sailDates) {
                if (newValue.some(r=>r.key=="sailDates")) {
                    this.selectedAlls.sailDates = false
                }
            }

            if (this.selectedAlls.shipCodes) {
                if (newValue.some(r=>r.key=="shipCodes")) {
                    this.selectedAlls.shipCodes = false
                }
            }

            if (this.selectedAlls.destinations) {
                if (newValue.some(r=>r.key=="destinations")) {
                    this.selectedAlls.destinations = false
                }
            }

            if (this.selectedAlls.sailDays) {
                if (newValue.some(r=>r.key=="sailDays")) {
                    this.selectedAlls.sailDays = false
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.list-select-con {
    background-color: #ffffff;
    border: solid 1px #d3dadd;
    border-bottom: solid 1px #006ab9;
    margin-bottom: 20px;
    .list-select-result-con {
        padding: 5px 22px 0;
        min-height: 60px;
        line-height: 55px;
        .result-text {
            color: #747d80;
            min-width: 46px;
            margin-right: 10px;
            float: left;
        }
        .result-con {
            max-width: 900px;
            margin-top: 14px;
            float: left;
            .result-item {
                height: 25px;
                padding-right: 8px;
                border: solid 1px #d3dadd;
                font-size: 12px;
                margin: 0px 0 14px;
                color: #747d80;
                float: left;
                margin-right: 10px;
                cursor: pointer;
                .result-item-label {
                    padding: 0 8px;
                    margin-right: 8px;
                    background-color: #f3f6f8;
                    height: 100%;
                    float: left;
                    line-height: 25px;
                }
            }
        }
        .result-clear-all {
            cursor: pointer;
            float: right;
        }
    }

    .list-select-list-con {
        padding: 10px 22px 0;
        .select-item {
            font-size: unset;
            line-height: unset;
            padding: 3px 0;
            min-height: 40px;
            clear: both;
            .select-label {
                width: 82px;
                font-size: 14px;
                color: #747d80;
                font-weight: normal;
                margin: 10px 0;
                float: left;
                text-align: right;
            }
            .address-select-con {
                color: #282b2c;
                position: relative;
                float: left;
            }
            .check-item-con {
                margin: 10px 0;
                margin-right: 25px;
                float: left;
                position: relative;
                cursor: pointer;
                .selected-icon {
                    display: none;
                }
                .unselected-icon {
                    display: block;
                }
                .disable-icon {
                    display: none;
                }
                .check-item-con-ship-tonnage {
                    position: absolute;
                    top: 24px;
                    left: 26px;
                    max-width: 200px;
                    z-index: 10;
                    .tonnage-tooltip-arrow {
                        position: absolute;
                        width: 0;
                        height: 0;
                        border-color: transparent;
                        border-style: solid;
                        top: -5px;
                        left: 32px;
                        margin-left: -5px;
                        border-width: 0 5px 5px;
                        border-bottom-color: #54a3de;
                    }
                    .tonnage-tooltip-inner {
                        width: 200px;
                        padding: 3px 8px;
                        color: #fff;
                        text-align: center;
                        background-color: #54a3de;
                        border-radius: 4px;
                    }
                }
            }
            .check-item-con.active {
                .selected-icon {
                    display: block;
                }
                .unselected-icon {
                    display: none;
                }
                .disable-icon {
                    display: none;
                }
            }
            .check-item-con.disable {
                color: #a6aeb1;
                .selected-icon {
                    display: none;
                }
                .unselected-icon {
                    display: none;
                }
                .disable-icon {
                    display: block;
                }
            }
        }
        .select-item::after {
            content: '';
            /* 必须是块级元素 clear 才生效，否则容器高度塌陷，多行时内容溢出与后续区块重叠 */
            display: block;
            clear: both;
        }
        .select-left {
            margin-left: 15px;
            max-width: 945px;
            min-width: 800px;
        }
        .select-item-list-con {
            float: left;
        }
        .time-year {
            margin-right: 10px;
            font-size: 14px;
            color: #a6aeb1;
            line-height: 40px;
            font-weight: normal;
        }
        .select-time-more-con {
            font-size: 14px;
            color: #006ab9;
            margin: 10px 0;
            float: right;
            .select-time-more {
                float: left;
                cursor: pointer;
            }
        }
        .css_destination {
            margin-right: 35px;
        }
        .address-select-item-box {
            position: relative;
            float: left;
            .address-select-item-con {
                padding: 10px 14px;
                margin-right: 30px;
                z-index: 2;
                position: relative;
                float: left;
                cursor: pointer;
                border: solid 1px transparent;
                .address-selected-icon {
                    display: none;
                }
                .address-unselected-icon {
                    display: block;
                }
            }
            .address-select-list-con {
                position: absolute;
                top: 40px;
                // display: none;
                width: 1003px;
                z-index: 1;
                background-color: #f3f6f8;
                border: solid 1px #d3dadd;
                padding-left: 15px;
                .address-select-product {
                    position: relative;
                    width: 100%;
                    min-height: 42px;
                    border-bottom: 1px rgb(211, 218, 221) dashed;
                    .address-select-product-name {
                        display: inline-block;
                        vertical-align: top;
                        margin: 10px 20px 0 0;
                        .name-line {
                            width: 4px;
                            height: 15px;
                            margin-right: 5px;
                            display: inline-block;
                            vertical-align: middle;
                            background-color: #fbc500;
                        }
                        .name-text {
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }
                    .address-select-product-items {
                        display: inline-block;
                        vertical-align: top;
                        max-width: 84%;
                        .check-item-con {
                            margin-right: 18px;
                        }
                    }
                }
                .address-select-product::after {
                    content: '';
                    clear: both;
                }
                .address-select-product:last-child {
                    border-bottom: none;
                }
            }
        }
        #selectMore {
            height: 0;
            position: relative;
            overflow: hidden;
            -webkit-transition: height 0.2s;
            -moz-transition: height 0.2s;
            -o-transition: height 0.2s;
            transition: height 0.2s;
        }
        #selectMore.showMoreSelect {
            height: auto;
        }
        .list-more-select-con {
            width: 100%;
            margin: 0 auto;
            cursor: pointer;
            .more-container {
                width: 251px;
                height: 24px;
                background-color: #0073bb;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
                font-size: 14px;
                color: #ffffff;
                margin: 0 auto;
                text-align: center;
                line-height: 24px;
            }
        }
        .goto-hp {
            float: right;
            position: relative;
            top: -17px;
            overflow: hidden;
            width: 248px;
            height: 42px;
            .changeHomeCruise {
                position: absolute;
                left: 95px;
            }
        }
        .line {
            width: 100%;
            height: 1px;
            background-color: #e5e9eb;
        }
    }
    .red-dot {
        position: absolute;
        width: 5px;
        height: 5px;
        right: 26px;
        top: 11px;
        border-radius: 2.5px;
        background-color: red;
    }
    .rotate180 {
        transform: rotate(180deg);
    }
}
</style>
